import React from 'react'
import  {Routes, Route} from "react-router-dom";
import TeacherHome from "../home/teacherHome/TeacherHome";
import Students from "../pages/studentPages/Students";
import StudentDetails from "../pages/studentPages/StudentDetails";
import TeacherClasses from '../pages/teacherPages/classes/teacherClasses/TeacherClasses';
import LessonCalendar from "../pages/calendars/LessonCalendar";
import Profile from "../pages/teacherPages/profile/Profile";
import LessonInfo from "../pages/teacherPages/lessonInfo/LessonInfo";
import Feedback from "../pages/feedback/Feedback";
import Administration from '../pages/teacherPages/adminstration/Administration';
import TeacherSlots from '../pages/teacherPages/classes/teacherClasses/TeacherSlots'
import CompletedTeacherLessons from '../pages/teacherPages/classes/teacherClasses/CompletedTeacheLessons';
import AwaitingTeacherLessons from '../pages/teacherPages/classes/teacherClasses/AwaitingTeacherLessons';
import TodaysTeacherLessons from '../pages/teacherPages/classes/teacherClasses/TodaysTeacherLessons';
import GoogleDriveBooks from '../pages/teacherPages/books/googleDriverBooks/GoogleDriveBooks';
import Contact from '../pages/contact/Contact';
import Navbar from '../components/navbar/Navbar';
import LessonRoom from '../pages/lessonRoom/LessonRoom';
const TeacherRouter = () => {
  return (
 <> 
 <Navbar />
   <Routes>
        <Route path='/home' element={<TeacherHome/>}/> 
        <Route path='/students' element={<Students/>}/>
        <Route path='/students/:id' element={<StudentDetails />} />
        <Route path='/classes' element={<TeacherClasses/>}/>
        <Route path='/books' element={<GoogleDriveBooks/>}/>
        <Route path='/calendar' element={<LessonCalendar />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/lessoninfo' element={<LessonInfo />} />
        <Route path='/feedback' element={<Feedback />} />
        <Route path='/administration' element={<Administration />} />
        <Route path='/slots' element={<TeacherSlots />}/>
        <Route path='completed-teacher-lessons' element={<CompletedTeacherLessons />}/>
        <Route path='awaiting-teacher-lessons' element={<AwaitingTeacherLessons />}/>
        <Route path='today-teacher-lessons' element={<TodaysTeacherLessons />}/>
        <Route path='/contact' element={<Contact />} />
        <Route path='/lesson/:eventId' element={<LessonRoom />} />
   </Routes>
 </>
    )
}

export default TeacherRouter
